// @flow

import React from "react";

import cx from "classnames";
import RadioButton from "../RadioButton";
import styles from "./RadioGroup.scss";

import type { InputType } from "../Input/TextInput";

export type Options = {
  value: string,
  label: string
};

type RadioGroupProps = {
  input: InputType,
  options: Array<Options>,
  isDisabled: boolean,
  additionalStyles?: string
};

const RadioGroup = ({ input, options, isDisabled, additionalStyles }: RadioGroupProps) => (
  <div className={cx(styles.container, additionalStyles)}>
    {options.map(({ value, label }) => {
      const id = `${label}-${String(value)}-${input.name}`;
      return (
        <RadioButton
          input={input}
          checked={input.value === value}
          key={id}
          id={id}
          value={value}
          label={label}
          isDisabled={isDisabled}
        />
      );
    })}
  </div>
);

export default RadioGroup;
